import React from 'react'
import Hero from '../Components/Hero'
import Navbar from '../Components/Navbar'

function About() {
  return (
    <>
    <Navbar />
    <Hero />
    </>
  )
}

export default About